// hooks
import { useParams, useNavigate } from 'react-router-dom';
import useResponsive from 'src/hooks/useResponsive';

// components
import LoadingScreen from 'src/components/LoadingScreen';
import { useSelector } from 'src/redux/store';

import { NAVBAR } from '../../config';
import { ChatInternoSidebar, ChatInternoWindow } from 'src/sections/@chats/chatInterno';
import EmptyContentChat from 'src/components/EmptyContentChat';
import { Card } from 'src/@/components/ui/card';

export default function ChatInterno() {
  const { conversationKey } = useParams();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.staff);
  const isMobile = useResponsive('down', 'lg');

  const layoutMode = localStorage.getItem('layoutMode') || 'navbar';
  const shouldAddMarginTop = isMobile && layoutMode === 'navbar';
  const heightOffset = layoutMode === 'sidebar' ? 0 : NAVBAR.DASHBOARD_ITEM_HORIZONTAL_HEIGHT + 30;

  return (
    <div
      style={{
        height: layoutMode === 'sidebar' ? '100vh' : `calc(100vh - ${heightOffset}px)`,
      }}
      className={`flex overflow-hidden ${shouldAddMarginTop ? 'mt-14' : ''} bg-neutral-100 dark:bg-[#0D0D0D]`}
    >
      <div className="flex-1 flex gap-2 p-3 overflow-hidden">
        {/* Sidebar */}
        {(!isMobile || !conversationKey) && (
          <Card className="w-full min-w-0 md:w-[400px] md:min-w-[340px] flex-shrink-0 flex flex-col p-0">
            <ChatInternoSidebar />
          </Card>
        )}

        {/* Main content */}
        {(!isMobile || conversationKey) && (
          <Card className="flex-1 flex flex-col min-w-0">
            {/* Botão voltar mobile */}
            {isMobile && conversationKey && (
              <button
                onClick={() => navigate('/chats/interno')}
                className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 border-b border-gray-100 flex-shrink-0 md:hidden"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                Voltar
              </button>
            )}
            {conversationKey && loading ? (
              <LoadingScreen />
            ) : conversationKey ? (
              <ChatInternoWindow />
            ) : (
              <EmptyContentChat title="Selecione uma conversa" />
            )}
          </Card>
        )}
      </div>
    </div>
  );
}
